import { Mark } from '@tiptap/core'

const GlobalVariableLink = Mark.create({
  name: 'globalVariableLink',

  addAttributes () {
    return {
      variable: {
        default: null,
        parseHTML: element => element.getAttribute('data-glink') || null,
        renderHTML: attrs => ({
          'data-glink': attrs.variable
        })
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'a[data-glink]'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    const variable = HTMLAttributes.variable || HTMLAttributes['data-glink'] || ''

    const attrs = {
      ...HTMLAttributes,
      href: '#' + variable,
      'data-glink': variable,
      target: '_blank'
    }

    delete attrs.variable

    return ['a', attrs, 0]
  },

  addCommands () {
    return {
      globalVariableLink: attrs => ({ state, dispatch }) => {
        const { from, to } = state.selection
        const type = this.type
        let tr = state.tr

        if (attrs && attrs.remove) {
          tr = tr.removeMark(from, to, type)

          const selectedText = state.doc.textBetween(from, to, ' ')
          const cleanedText = selectedText.replace(/\[\[\s*[^]]+\s*\]\]/, '').trim()

          if (cleanedText) {
            tr = tr.insertText(cleanedText, from, to)
          } else {
            tr = tr.delete(from, to)
          }

          if (dispatch) {
            dispatch(tr.scrollIntoView())
          }

          return true
        }

        tr = tr.removeMark(from, to, type)
        tr = tr.delete(from, to)

        const selectedText = state.doc.textBetween(from, to, ' ')
        const variableText = `[[ ${selectedText} ]]`
        const textNode = state.schema.text(variableText, [type.create(attrs)])
        tr = tr.insert(from, textNode)

        if (dispatch) {
          dispatch(tr.scrollIntoView())
        }

        return true
      }
    }
  }
})

export default GlobalVariableLink
